import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'
import Resume from '../assets/images/resume.pdf'
import '../assets/scss/main.scss'

class HomeIndex extends React.Component {

    render() {
        const siteTitle = "Abby Krishnan"
        const siteDescription = "Site description"

        return (
            <Layout>
                <Helmet>
                        <title>{siteTitle}</title>
                        <meta name="description" content={siteDescription} />
                </Helmet>
                <div id="main">
                    <section id="one">
                        <div class="title"> Home </div>
                        <header className="major">
                            <h2>About Me</h2>
                        </header>
                        <p> My name is Abby Krishnan! I study Computer Science and Public Policy at UT Austin. 🤘🏽
                        <br></br>
                        <br></br>
                        Some things I'm interested in:
                        <ul>
                            <li> How systems knowledge can be used to write better regulation for tech platforms </li>
                            <li> How we can empower local governance to work better for people </li>
                            <li> How online privacy influences political processes. </li>
                        </ul>
                        If you work in these fields, or do any any form of social computing research, I'd love to chat more about your work. Email me!
                        <br></br>
                        <br></br>
                        Some tidbits about me:
                            <ul>
                                <li> I love food, civic tech, and reading. </li>
                                <li> I started an organization at UT called the <a href="https://txctp.org"> Texas Civic Tech Project</a>, for students in tech looking to impact civic society in a positive way. We work on projects, volunteer, and recently wrote a magazine!</li>
                                <li> I've interned at <a href="https://www.affirm.com/"> Affirm </a> , Facebook's Election Team, and more. </li>
                                <li> I currently research with the <a href="http://utsaslab.cs.utexas.edu/"> UT Systems Lab </a> researching the intersection of privacy law and systems. </li>
                                <li> I love registering voters and working with students through TX Votes, UT's premier nonpartisan civic engagement organization. </li>
                                <li> Visiting Austin? I help manage a <a href="https://bit.ly/FoodSheet"> food spreadsheet</a> reviewing Austin restaurants. </li>
                            </ul>
                        </p>
                    </section>
                    <section id="two">
                        <header className="major">
                            <h2>Contact me</h2>
                        </header>
                        <p> Email me, send me a book recommendation, or take a look at my resume to get in touch (linked below!) </p>
                        <ul className="icons">
                            <li><a href="abbykrishnan@utexas.edu" className="icon fa-envelope-o"><span className="label">Email</span></a></li>
                            <li><a href="https://twitter.com/theamazingabby" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
                            <li><a href="https://github.com/abbykrish" className="icon fa-github"><span className="label">Github</span></a></li>
                            <li><a href="https://www.linkedin.com/in/abbykrish/" className="icon fa-linkedin"><span className="label">LinkedIn</span></a></li>
                            <li><a href="https://www.goodreads.com/user/show/68621097-abby-krishnan" className="icon fa-book"><span className="label">Reading</span></a></li>
                            <li><a href={Resume} className="icon fa-file"><span className="label">Resume</span></a></li>
                        </ul>
                    </section>
                </div>

            </Layout>
        )
    }
}

export default HomeIndex